export class Navigation {
	constructor() {
		this.open = false
		this.toggle = document.querySelectorAll('[data-toggle-nav]')

		this.toggle.forEach((button) => {
			button.addEventListener('click', () => {
				this.open ? this.closeNavigation() : this.openNavigation()
			})
		})
	}
	openNavigation() {
		this.open = true
		document.documentElement.dataset.navigation = 'open'
	}
	closeNavigation() {
		this.open = false
		document.documentElement.dataset.navigation = 'closed'
	}
	snapCloseNavigation() {}
}

export default () => {}